// src/pages/AdmissionBrochurePage.js
import React from 'react';
import Layout from '../components/Layout/Layout';
import brochurePdf from '../images/admisssion-brouchere.pdf';

const AdmissionBrochurePage = () => {
  return (
    <Layout>
      <div className="page-container" style={{ maxWidth: '1000px', margin: '40px auto', padding: '0 20px' }}>
        <h2 style={{ color: 'var(--primary-blue)', borderBottom: '2px solid var(--light-blue)', paddingBottom: '10px', marginBottom: '30px', textAlign: 'center' }}>
          Admission Brochure
        </h2>
        
        <div style={{ backgroundColor: '#fff', padding: '0', borderRadius: '4px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
          <iframe src={brochurePdf} width="100%" height="800px" title="Admission Brochure" style={{ border: 'none' }} />
        </div>
      </div>
    </Layout>
  );
};

export default AdmissionBrochurePage;
